import React from 'react';

export default () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 226 196.9"
    enableBackground="new 0 0 226 196.9"
    className="header__logo"
  >
    <g>
      <g>
        <path
          fill="#FFFFFF"
          d="M113,0C50.6,0,0,50.6,0,113c0,32.8,14,62.4,36.4,83.1h153.2C212,175.4,226,145.8,226,113
			C226,50.6,175.4,0,113,0z M144.8,195.7c0,0-1.1,0.5-2.5,0.3c-1.4-0.1-2.7-0.7-2.7-0.7s-1.2,0.2-2.9-0.2
			c-1.7-0.5-10.6-3.1-10.6-3.1l-45.8,0c-0.6,0.3-1.3,0.6-2.1,0.8c-3.4,0.9-6.6,2.6-10.2,2.7c-3.6,0.1-6,0.2-6.6-0.7
			c0,0-1.5-0.3-1.1-1.8c0.3-1.5,1.5-3.3,2.4-4c0.5-0.4,1.8-0.5,3.3-0.7c-3.5-0.9-7.4-2.4-12.1-5.2c-9.2-5.4-15.9-16.2-15.9-16.2
			l0.4-0.2l-0.4-0.3l0.2-0.2l-0.6-0.2c0,0,2.3-1.3,4.1-1.1c1.9,0.2,3,0.7,7.7,5c4.8,4.4,7.8,6.2,14.6,9.8c3.2,1.7,6.1,2.2,8.4,2.4
			c-0.3-0.8-0.5-1.6-0.6-2c-0.4-1.4-1.8-3.8-2.5-4.7c-0.7-0.9-1.7-9.1-1.8-10.6c-0.1-1.5,1.4-4.9,1.7-5.6c0.3-0.7,1.4-5.1,3.9-9.7
			c2.5-4.6,8.1-3.4,8.1-3.4s0.8-0.8,1.4-2.2c0.6-1.3,0.7-5.2,0-7.6c-0.8-2.4-0.7-8-0.6-12.1c0.1-4,3.5-15.2,3.5-15.2
			s-0.1-1.8-0.3-3.7c-0.3-1.9,2.2-8.8,3.1-12.4s3.6-5.3,4.5-7c0.9-1.7,0.7-9.7,0.7-9.7c0.1-2-0.1-2.9-0.3-3.5
			c-0.3-0.2-0.4-0.4-0.4-0.4s-0.2,0.9-0.2,1.7c0,0.8,0,4-0.3,5.3c-0.2,1.3-1.6,2.9-2.9,3.5c-1.2,0.6-9.8-6.2-10.5-7.1
			c-0.7-0.9-2.7-3.2-1.8-5.7s1.6-2.6,2.4-4.1c0.9-1.5,2.4-6.6,3.1-7.9c0.7-1.3,0.9-1.8,1.8-2.2c1-0.4,2.9-0.9,4.5-2.3
			c1.5-1.4,3.9-6.3,7.8-9.3c3.9-3,8.9-3.8,9.5-4c0.6-0.2,0.6-0.6,0.6-0.6c0.7-1.5,5.6-1.5,8.6-1.3c3.1,0.2,3.9,0.9,3.9,0.9
			s2.4,0.8,3.4,1.2c1,0.4,0.8,1.3,1,3c0.2,1.6,0,4.3-0.4,6.2c-0.3,2,0.3,3.5,0.6,4.9c0.3,1.4,0.4,2.7-0.2,3c-0.5,0.3-1.5-0.1-2.7-2
			c-1.2-1.9-1.8-5.9-1.8-5.8c0,0.2,0.4,1.8,0.3,3.1c-0.1,1.3,0.6,3.3,0.7,3.8c0.1,0.5,0.6,1,0.6,1c0.5,0.4,1.6,2.1,1.7,2.6
			c0.1,0.5,0.7,1.9,1.1,2.4c0.4,0.5,1.1,1.6,1.7,3.4c0.6,1.8,1.1,4.3,1.3,5.6c0.2,1.4-0.2,2-1,2.4c-0.8,0.5-2.1,0-2.1,0
			c-0.4,0.8-1.4,1.9-3.5,3.2c-0.5,0.3-1,0.5-1.6,0.7l0.7,5.2l3.7,2.7c0,0,3,3.1,6.8,7.9c3.8,4.8,4.3,15.6,4.1,24.8
			c-0.2,7.5-3,12.5-4.1,14c-0.2,0.4-0.2,0.8-0.1,0.9c0.4,0.6,0.5,1.6,0.8,2.5c0.4,1.1,0.5,13.5,0.5,13.5c0.9,0.9,4.8,5.6,5.7,7.2
			c0.9,1.6,1.3,6,0.9,10.6c-0.3,3.2-4.4,10.6-6.9,14.1l0.2,4.3c0.9,0.6,2.6,1.5,4.3,1.6c2.5,0.1,7.5,0.2,9,2.3
			c1.6,2,2.5,3.3,2.4,4.6C146.5,195.9,144.8,195.7,144.8,195.7z"
        />
      </g>
    </g>
    <path
      fill="#FFFFFF"
      d="M128.6,112.1c2.4,0.1,4.4,1.5,4.4,1.5c-1.4-1.3-4.4-1.7-4.4-1.7s-0.3,0-0.6,0c0-0.1,0-0.3-0.1-0.4
	c0.2-0.1,0.7-0.4,1.1-0.6c3.6-1.3,6.7-1.5,6.7-1.5c-1.2-0.1-4.5,0.7-6.2,1.2c0.5-0.3,1-0.7,1.4-1c1.1-1,2.1-3,2.1-3s-0.9,1.6-2,2.7
	c-0.5,0.5-1.3,1-2,1.4c-0.4,0.1-0.6,0.2-0.6,0.2s-0.4,0.1-0.7,0.3c-0.1-0.1,0-0.2,0-0.2c0-0.3-0.4-0.6-0.7-0.8c0,0,0,0,0,0
	c0,0,0.1,0,0.1,0s3-1.4,3.8-2.8c0,0-1.2,1.5-3.9,2.7c0,0-0.1,0-0.1,0c-0.3-0.2-0.8-0.4-0.8-0.6c0-0.2-0.3-1.1-0.6-1.4
	c-0.3-0.2-0.8-1.8-1-2.4c-0.2-0.6-0.9-0.7-1.3-0.9c-0.4-0.2-1.1-1-1.2-1.3c0-0.2-0.7-0.4-0.9-0.4c0,0,0,0,0,0
	c0.2-0.3,0.5-0.5,0.7-0.6c-0.1,0.1-0.3,0.2-0.5,0.3c-0.3,0.3-0.5,0.3-0.5,0.3c0.1-0.3,0.8-0.8,0.8-0.8c-0.2,0.1-0.5,0.4-0.7,0.6
	c-0.2,0.2-0.4,0.1-0.4,0.1c0.2-0.5,1.1-1,1.1-1c-0.5,0.2-1.2,0.8-1.3,1c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0.5-0.8,1.1-1.2,1.1-1.2
	c-0.4,0.2-0.9,0.8-1.1,1.1c0-0.1,0-0.3,0-0.5c0.1-0.2,0.2-0.3,0.2-0.3c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1-1.2-0.2-3.5-0.5-5.1
	c-0.3-2.2-1-5.5-2.2-4.4c-1.2,1.1-3.9,5.1-5.1,10.1L111,103l0.1-0.3l-0.5,0.3l-2.3,1c0,0-1.7-4-3.4-6.2c-1.7-2.1-3.7-2.8-4.8-1.2
	c-1.1,1.5-1.7,6.1-1.4,9.6c0.3,3.5,1.3,6.7,1.7,7.3c0,0,0.1,2.1,1.1,4.8c1,2.7,3.1,5.8,4,7.3c0.9,1.5,0.8,2.6,0.6,3.1
	c-0.2,0.5-4,6.8-4.8,8.6c-0.8,1.8-2.1,6.7-2.1,6.9c0,0.2-0.5,0.7-1.3,1.7c0,0-10.1,12.8-11.1,18.8l-0.9,6c0,0-1.9,6.9-1.5,12.1
	c0.4,5.2,0.6,6.7,0.6,6.7s-3.1,0.4-3.8,3.3c-0.7,3.2,2.4,4.1,5.8,4.1c3.3,0,38.6-1.1,38.6-1.1s0.7,0.1,0.6-0.1
	c1-0.2,3.3-0.7,3.8-1.1c0.7-0.6,1-1.7,0.5-2.3c-0.5-0.6-2.5-1.4-3.5-1.5l-1-0.1c0,0-0.9-0.7-1.3-2.5c-0.4-1.8-1.4-7.4-1.5-8.3
	c-0.1-1-0.5-3.6-0.5-4.1c0-0.6,0.4-4.3,0.5-4.9c0.1-1.1,0.2-5.2,0.4-7.1c0,0-0.4-0.9,0.7-3.1c0.1-0.2,0.2-0.4,0.3-0.6
	c0.4-0.8,0.7-1.5,0.9-2.1c0,0,0.2,0.5,0.3,0.8c0-0.3,0-0.8,0-1c-0.1-0.2,0-0.1,0-0.1s0.3,0.9,0.5,1c0,0-0.4-0.9-0.3-1.3
	c0.1-0.4,0.2-0.7,0.2-0.7s0,0.8,0.1,1c0,0,0.2-1.1,0.1-1.6c0,0,0.3,0.4,0.5,0.6c0-0.2,0.1-1.1,0.2-1.5c0.1-0.4,0.2-0.5,0.2-0.5
	l0.2,0.4c0,0-0.1-0.9,0-1.2c0.1-0.3,0.6-2.3,0.7-2.9c0.1-0.6,0.5-4.5-0.9-7.3c-1.4-2.8-4.8-9.8-5.3-11.6c-0.6-1.8-1.1-3.4-0.6-5.1
	c0.3-1.1,1-2.8,1.7-4c0,0,0,0,0,0c0.3-0.5,1.8-2.3,2.5-2.9c0.7-0.5,1-0.5,1.9-2.1c1-1.6,0-3.7,0-3.7l0.1-0.2c0.5-0.2,0.5-1,0.5-1
	s0,0,0-0.1c0.5,0.4,1.2,0.8,1.7,1.1c0.8,0.5,1.9,0.9,1.9,0.9s-1.1-0.5-1.7-0.8c-0.4-0.2-1.2-0.8-1.8-1.2c0,0,0,0,0,0
	c0.3-0.1,0.2-0.7,0.1-0.8c0,0,0,0,0-0.1C128.1,112.1,128.3,112.1,128.6,112.1 M127.9,111.4C127.9,111.4,127.9,111.4,127.9,111.4
	c0.1-0.1,0.1-0.1,0.2-0.1C128,111.3,127.9,111.3,127.9,111.4"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/Logo.js